import { Component, Input, OnInit } from '@angular/core';
import { FormGroup, FormBuilder } from '@angular/forms';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormatterService } from 'src/app/utils/formatter/formatter.service';

@Component({
  selector: 'app-actualizacion-stock-view',
  templateUrl: './actualizacion-stock-view.component.html',
  styles: [
  ]
})
export class ActualizacionStockViewComponent implements OnInit {

  @Input() element: any = null;
  form: FormGroup = new FormGroup({});

  columnas = [
    {
      label: 'Producto',
      value: (element: any) => {
        return element.stock.producto.nombre;
      },
      responsive: ['XS', 'SM', 'MD']
    },
    {
      label: 'Cantidad',
      value: (element: any) => {
        return this.formatter.numberFormat(element.cantidad);
      },
      responsive: ['XS', 'SM', 'MD']
    },
  ]

  constructor(
    private formBuilder: FormBuilder,
    public activeModal: NgbActiveModal,
    private formatter: FormatterService
  ) { }

  ngOnInit(): void {
    this.form = this.formBuilder.group({
      tipo_actualizacion: [null],
      fecha: [null],
      detalle: [null]
    });

    this.form.patchValue({
      fecha: this.formatter.dateFormat(this.element.fecha),
      tipo_actualizacion: this.element.tipo_actualizacion.nombre,
      detalle: (this.element.detalle) ? this.element.detalle : 'Sin Información'
    });

    this.form.disable()

  }

}
